export default __webpack_public_path__ + "static/media/pagarme.0eb8b369.png";